import { useMutation } from "@tanstack/react-query";
import { AlgoregSessionApiClient } from "./api-client";
import {
  AlgoregSessionIdContainer,
  InitAlgoregSessionRequestDto,
  AlgoregSessionState
} from "./types";

export const useAlgoregSession = () => {
  const initAlgoregSessionMutation = () =>
    useMutation<AlgoregSessionState, Error, InitAlgoregSessionRequestDto>({
      mutationFn: async (data) => await AlgoregSessionApiClient.initAlgoregSession(data)
    });

  const finishAlgoregSessionMutation = () =>
    useMutation<AlgoregSessionState, Error, AlgoregSessionIdContainer>({
      mutationFn: async (data) => await AlgoregSessionApiClient.finishAlgoregSession(data)
    });

  return {
    initAlgoregSessionMutation,
    finishAlgoregSessionMutation
  };
};
